import { h, forceUpdate, } from "@stencil/core";
import { ICON_NAMESPACE } from "../../../icons/namespace";
/** @internal */
export class EsToast {
  constructor() {
    this.defaultIcons = {
      success: [ICON_NAMESPACE, 'check'],
      info: [ICON_NAMESPACE, 'info'],
      warning: [ICON_NAMESPACE, 'warning'],
      error: [ICON_NAMESPACE, 'error'],
    };
    this.captureToast = (id) => (ref) => {
      if (ref) {
        this.loaf.set(id, ref);
      }
      else {
        this.loaf.delete(id);
      }
    };
    this.eatToast = (id) => async () => {
      const slice = this.loaf.get(id);
      await slice?.close();
      this.slices.delete(id);
      if (this.slices.size === 0) {
        this.host.parentNode?.removeChild(this.host);
      }
      else {
        forceUpdate(this);
      }
    };
    this.slices = new Map();
    this.loaf = new Map();
  }
  async popToast(level = 'error', { message, title, duration = 5000, icon = this.defaultIcons[level], onClick, }) {
    const id = `${level}-${title}-${message}`;
    if (this.slices.has(id)) {
      const burningToast = this.slices.get(id);
      clearTimeout(burningToast.timeout);
      burningToast.count += 1;
      burningToast.duration = duration;
      burningToast.timeout = setTimeout(this.eatToast(id), duration);
    }
    else {
      const toast = {
        id,
        message,
        title,
        level,
        icon,
        duration,
        onClick,
        count: 1,
        timeout: setTimeout(this.eatToast(id), duration),
      };
      this.slices.set(id, toast);
    }
    forceUpdate(this);
    return () => {
      const toast = this.slices.get(id);
      if (!toast)
        return;
      clearTimeout(toast.timeout);
      this.eatToast(id)();
    };
  }
  render() {
    return Array.from(this.slices, ([id, { count, level, title, message, icon, onClick }]) => (h("es-toast", { key: id, level: level, count: count, icon: icon, onClick: onClick, ref: this.captureToast(id), class: { clickable: !!onClick } }, h("strong", null, title), h("span", null, message))));
  }
  static get is() { return "es-toaster"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-toaster.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-toaster.css"]
    };
  }
  static get states() {
    return {
      "slices": {},
      "loaf": {}
    };
  }
  static get methods() {
    return {
      "popToast": {
        "complexType": {
          "signature": "(level: ToastLevel | undefined, { message, title, duration, icon, onClick, }: ToastOptions) => Promise<() => void>",
          "parameters": [{
              "tags": [],
              "text": ""
            }, {
              "tags": [],
              "text": ""
            }],
          "references": {
            "Promise": {
              "location": "global",
              "id": "global::Promise"
            },
            "ToastLevel": {
              "location": "import",
              "path": "../types",
              "id": "src/components/toast/types.ts::ToastLevel"
            },
            "ToastOptions": {
              "location": "import",
              "path": "../types",
              "id": "src/components/toast/types.ts::ToastOptions"
            },
            "Toast": {
              "location": "import",
              "path": "../types",
              "id": "src/components/toast/types.ts::Toast"
            }
          },
          "return": "Promise<() => void>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      }
    };
  }
  static get elementRef() { return "host"; }
}
//# sourceMappingURL=es-toaster.js.map
